import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FormComponent from "../../../components/commonComponent/QuestionnareForm";
import "../../../styles/Form.css";
import useFetchUserOptions from "../../../hooks/useFetchUserOptions";

const API_URL = process.env.REACT_APP_API_URL;

const AddQuestion = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const users = useFetchUserOptions(true);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    let formErrors = {};

    if (!title.trim()) {
      formErrors.title = "Title is required";
    }
    if (!description.trim() || description === "<p><br></p>") {
      formErrors.description = "Description is required";
    }
    if (Object.keys(formErrors).length > 0) {
      for (const key in formErrors) {
        toast.error(formErrors[key], { autoClose: 1000 });
      }
      return;
    }

    const newQuestion = {
      title,
      description,
      userId: selectedUsers.value,
    };

    try {
      await axios.post(`${API_URL}/questions/addQuestion`, newQuestion);
      toast.success("Question added successfully", {
        autoclose: 1000,
      });
      navigate("/questions");
    } catch (error) {
      toast.error("Error adding data", {
        autoClose: 1000,
      });
    }
  };


  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Question
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/questions")}
        >
          &times;
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <FormComponent
          title={title}
          setTitle={setTitle}
          description={description}
          setDescription={setDescription}
          isEditMode={false}
          users={users}
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          isAddMode={true}
        />
        <button
          type="submit"
          className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
        >
          Add Question
        </button>
      </form>
    </div>
  );
};

export default AddQuestion;
